import { initializeForm } from '../../utils/form';
import { validateNotEmpty } from '../../utils/validators';

$(() => {
  const companyDetailsForm = $('#COMPANY_DETAILS');
  const closeDisclaimer = $('#close-disclaimer');

  initializeForm(companyDetailsForm, {
    preventDefault: false,
    validate: (values) => {

      let fields = [
        'registered_name',
        'registration_number',
        'full_address',
        'postal_code',
        'user_relationship'
      ]

      const errors = {
        ...validateNotEmpty(values, fields),
      };

      const hasErrors = !$.isEmptyObject(errors);
      $('#auction-registration-next-button').attr('disabled', hasErrors);
      return errors;
    },
  });

  closeDisclaimer.on('click', () => {
    $('#account-disclaimer').slideUp();
  })
});
